
import { mapMutations } from 'vuex'
import NotificationCard from './NotificationCard.vue'
import AppDropdownProfile from './AppDropdownProfile.vue'
import { showFirstName } from '@/models/filters'

export default {
  name: 'HeaderBar',
  components: {
    NotificationCard,
    AppDropdownProfile,
  },
  filters: {
    showFirstName,
  },
  props: {
    isOpened: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      default() {},
    },
    img: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      isHidden: false,
      isNotificationOpen: false,
      notifications: [],
    }
  },
  computed: {
    isOpenNavBar() {
      return this.$store.state.isOpenNavBar
    },
    requiredDocuments() {
      return localStorage.required_documents
    },
    className() {
      return localStorage.className
    },
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown)
    this.getNotifications()

    // eslint-disable-next-line
    const pusher = new Pusher(process.env.PUSHER_KEY, {
      cluster: 'us2',
    })

    const channel = pusher.subscribe(
      `notification_user.${this.$store.state.credential.id}`
    )
    channel.bind('notification.created', (data) => {
      this.getNotifications()
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown)
  },
  methods: {
    ...mapMutations({ toggleClassModal: 'modal/toggleClassModal' }),
    hideElement() {
      this.isHidden = true
    },
    showElement() {
      this.isHidden = false
    },
    toggleNavBar() {
      this.$store.commit('navbar/toggleNavBar')
    },
    handleMouseOver() {
      if (window.matchMedia('(orientation: landscape)').matches) {
        this.hideElement()
      }
    },
    handleMouseLeave() {
      if (window.matchMedia('(orientation: landscape)').matches) {
        this.showElement()
      }
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.isDropdownOpen = false
      }
    },
    logout() {
      this.$store.dispatch('credential/clearToken')
      location.reload()
    },
    ...mapMutations({ toggleClassModal: 'modal/toggleClassModal' }),
    perfilToPtBr(perfil) {
      const perfils = new Map([
        ['student', ''],
        ['professor', 'Professor'],
        ['coordinator', 'Coordenador'],
      ])
      return perfils.get(perfil)
    },
    getNotifications() {
      this.$axios
        .get('/api/v1/notification-center/notifications', {
          params: { class_id: localStorage.classId },
        })
        .then((res) => {
          this.notifications = res.data
        })
    },
    deleteNotification(id) {
      this.$axios
        .delete(`/api/v1/notification-center/notifications/${id}/delete`)
        .then((res) => this.getNotifications())
    },
    goToNotification(notification) {
      this.deleteNotification(notification.id)
      this.isNotificationOpen = false
      this.$router.push(notification.url)
    },
  },
}
